import styles from "components/sections/search/RecommendedQueries.module.scss";
import SearchQueryTextBox from "components/textbox/SearchQueryTextBox";
import {useEffect, useState} from "react";
import {TAB_NAME_TO_CURATION_KEY} from "components/sections/search/SearchResult";
import {captureException} from "@sentry/nextjs";
import {Axios} from "api";


const RecommendedQueries = (props) => {
    const {category, searchQuery, recommendedQueries} = props;

    const queries = recommendedQueries;

    const handleQueryClick = (query) => {
        typeof mixpanel !== 'undefined' && mixpanel.track(
            'SearchSectionRecommendedQueryClick',
            {
                category,
                query,
            }
        );
        searchQuery(query);
    };

    return (
        <>
            {
                queries && queries.length > 0 &&
                <div className={styles.sectionContainer}>
                    <div className={styles.sectionTitleWrapper}>
                        <span className={styles.sectionTitle}>추천 검색어</span>
                    </div>
                    <div className={styles.queryListContainer}>
                        {
                            queries.slice(0, 10).map((query, i) => (
                                <SearchQueryTextBox
                                    key={i} query={query}
                                    onClick={() => handleQueryClick(query)}
                                />
                            ))
                        }
                    </div>
                </div>
            }
        </>
    );
};

export default RecommendedQueries;
